export default "__VITE_PUBLIC_ASSET__e7aaa769__"